<template>
    <table class="table table-sm table-hover table-condensed">
        <thead>
            <tr>
                <th>Arquivo</th>
                <th>Tamanho</th>
                <th>Upload em</th>
                <th>Assinaturas</th>
            </tr>
        </thead>
        <tbody>
            <tr @contextmenu.stop.prevent="showMenu($event, item)" v-for="(item, i) in files" :key="i">
                <td><span @click.stop.prevent="showMenu($event, item)"
                        @contextmenu.prevent="showMenu($event, item)" class="mx-2">
                        <i class="text-gray fa fa-caret-down"></i>
                        <i class="text-gray fa fa-bars"></i></span>
                    <span>{{item.arquivo_nome}}</span>
                </td>
                <td>{{item.arquivo_tamanho /1000}} mb</td>
                <td>{{formatDate(item.created_at)}}</td>
                <td class="d-flex align-content-start">
                    <span style="cursor:pointer;" class="badge mx-2 h-100" data-toggle="collapse"
                        :data-target="`#collapse${item.id}`" aria-expanded="false" :aria-controls="`collapse${item.id}`"
                        :class="{'badge-success': item.finished, 'badge-danger': !item.finished}">{{item.signatures}}
                    </span>
                    <span class="collapse" :id="`collapse${item.id}`">
                        <p v-for="assinatura in item.assinaturas" :key="assinatura.id" class="m-0">
                            <i v-if="assinatura.assinado" class="fa fa-check-circle text-green"></i>
                            <i v-else class="fa fa-times-circle text-red"></i> {{assinatura.assinatura_nome}}
                        </p>
                    </span>
                </td>
            </tr>
        </tbody>
    </table>
</template>
<script>
    export default {
        props: {
            files: {}
        },
        methods: {
            selectFile() {
                this.$emit('selectFile', this.file);
            },
            showMenu(event, file) {
                this.$emit('clickOpen', event, file);
            },
            showSignatures() {
                this.$emit('showSignatures', this.file);
            }
        }
    }
</script>